import React, { useState } from "react";
import { Copy, ExternalLink } from "lucide-react";
import Price_setup_pop from './Price_setup_pop';
import copy from "copy-to-clipboard";

function Setup_done({ groupNumber: initialGroupNumber, subDomain: initialSubDomain }) {
    const [openEditPopup, setOpenEditPopup] = useState(false);
    const [groupNumber, setGroupNumber] = useState(initialGroupNumber);
    const [subDomain, setSubDomain] = useState(initialSubDomain);
    const [copyTooltip, setCopyTooltip] = useState('Copy');

    const toogleEditPricingTool = () => setOpenEditPopup(prev => !prev);

    const submit_setup = (_subDomain, _groupNumber) => {
        setOpenEditPopup(false);
        setGroupNumber(_groupNumber);
        setSubDomain(_subDomain);
    };

    const Copytext = (e) => {
        copy(e.currentTarget.getAttribute('data-text'));
        setCopyTooltip("Copied");
        setTimeout(() => setCopyTooltip("Copy"), 600);
    };

    return (
        <div>
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-foreground">Pricing Tool</h3>
                <button
                    type="button"
                    onClick={toogleEditPricingTool}
                    className="text-sm text-accent hover:underline font-medium"
                >
                    Edit
                </button>
            </div>

            <div className="grid grid-cols-2 gap-6">
                <div>
                    <p className="text-sm text-muted-foreground mb-1">Group Number</p>
                    <p className="font-semibold text-foreground">{groupNumber}</p>
                </div>
                <div>
                    <p className="text-sm text-muted-foreground mb-1">Subdomain</p>
                    <div className="flex items-start gap-2">
                        <a
                            href={subDomain}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-accent hover:underline text-sm break-all leading-snug"
                        >
                            {subDomain}
                        </a>
                        <div className="flex items-center gap-1 shrink-0 mt-0.5">
                            <a href={subDomain} target="_blank" rel="noopener noreferrer">
                                <ExternalLink className="w-4 h-4 text-muted-foreground" />
                            </a>
                            <button
                                type="button"
                                data-text={subDomain}
                                onClick={Copytext}
                                title={copyTooltip}
                                className="cursor-pointer"
                            >
                                <Copy data-text={subDomain} className="w-4 h-4 text-muted-foreground" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {openEditPopup && (
                <Price_setup_pop
                    submit_Setup_Detail={submit_setup}
                    close_setup={toogleEditPricingTool}
                    titleText="Manage Pricing Tool"
                    detailText="Setup or edit your unique web and mobile app pricing tool link by selecting the group number to use below"
                    popupName="editPricingTool"
                    btnText="Update"
                    groupNumber={groupNumber}
                    subDomain={subDomain}
                />
            )}
        </div>
    );
}

export default Setup_done;
